import { getAppInfo } from 'util/appInfo';
import { ScreenSharePresets, TrackPublishOptions } from 'livekit-client';

const { isK } = getAppInfo();

const SCREEN_SHARE_PRESETS: Record<'K' | 'F', TrackPublishOptions> = {
    K: {
        videoSimulcastLayers: [ScreenSharePresets.h1080fps15, ScreenSharePresets.h1080fps30],
        simulcast: true,
        screenShareEncoding: {
            maxBitrate: ScreenSharePresets.h1080fps30.encoding.maxBitrate,
            maxFramerate: ScreenSharePresets.h1080fps30.encoding.maxFramerate,
            priority: 'high',
        },
    },
    F: {
        videoSimulcastLayers: [ScreenSharePresets.h360fps3, ScreenSharePresets.h720fps15, ScreenSharePresets.h720fps30],
        simulcast: true,
        screenShareEncoding: {
            maxBitrate: ScreenSharePresets.h720fps30.encoding.maxBitrate,
            maxFramerate: ScreenSharePresets.h720fps30.encoding.maxFramerate,
            priority: 'high',
        },
    },
};

export const CURRENT_SCREEEN_SHARING_PRESET = isK ? SCREEN_SHARE_PRESETS.K : SCREEN_SHARE_PRESETS.F;
